import { withStyles } from "@material-ui/styles";
import AppConfig from "Config/AppConfig";
import CropImageModal from "Modals/CropImageModal";
import React, { Component } from "react";
import styles from "./styles";

class ProfilePictureForm extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      showModal: false,
      file: null,
      imageError: false,
    };
  }

  readUrl = () => {
    const img = this.fileInput.current.files[0];
    var reader = new FileReader();

    reader.readAsDataURL(img);

    reader.onload = () => {
      this.setState({
        showModal: true,
        file: reader.result,
      });
    };
  };

  addDefaultSrc = (e) => {
    this.setState({ imageError: true });
  };

  render() {
    const { classes, avatar, handleSubmit } = this.props;
    const { showModal, file, error, imageError } = this.state;
    const DefaultAvatar = AppConfig.NoProfilePic;

    const useDefaultImage = imageError || !avatar;

    return (
      <div className={classes.settings}>
        <CropImageModal
          show={showModal}
          onHide={() =>
            this.setState({
              showModal: false,
            })
          }
          detail={file}
          handleSubmit={handleSubmit}
          error={error}
        />
        <div>
          Update Profile Avatar{" "}
          {useDefaultImage && "(You're currently using a random avatar)"}
        </div>
        <div className={classes.imageContainer}>
          <input
            type="file"
            style={{ display: "none" }}
            id={"imgupload"}
            onChange={this.readUrl}
            ref={this.fileInput}
          />
          <label htmlFor={"imgupload"}>
            <div className={classes.image}>
              {useDefaultImage ? (
                <DefaultAvatar size={150} />
              ) : (
                <img
                  src={avatar}
                  alt="Profile Pic"
                  onError={this.addDefaultSrc}
                />
              )}
            </div>
          </label>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ProfilePictureForm);
